import React, { useMemo } from "react";
import { BiX } from "react-icons/bi";

import { IVideoToggleIcon } from "./types";
import { widgetUtils } from "./utils";

const VideoToggleIcon = ({
  icon,
  shape,
  message,
  hasNotificationBadge = false,
  notificationMessageColor
}: IVideoToggleIcon) => {
  const correctSrc = useMemo(() => {
    return icon.value && (icon.value as any) instanceof File
      ? URL.createObjectURL(icon.value as any)
      : icon.value;
  }, [icon]);

  if (shape === "circular")
    return (
      <div className="tw-w-[100px] tw-h-[100px] tw-relative">
        <div className="tw-absolute tw-right-0.5 tw-p-0.5 tw-z-[1]">
          <button
            type="button"
            disabled
            className="tw-bg-black tw-rounded-[14px] tw-w-3.5 tw-h-3.5 tw-max-w-3.5 tw-max-h-3.5 tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-white"
          >
            <BiX size={14} className="tw-shrink-0" />
          </button>
        </div>
        <div
          className={`tw-w-full tw-h-[100px] tw-p-0.5 tw-left-0 tw-top-0 tw-absolute tw-bg-black/30 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-tl-[47px] tw-rounded-tr-[14px] ${
            hasNotificationBadge
              ? "tw-rounded-bl-[14px]"
              : "tw-rounded-bl-[47px]"
          } tw-rounded-br-[47px] tw-justify-end tw-items-start tw-gap-2.5 tw-inline-flex`}
        ></div>
        <button
          className="tw-w-[100px] tw-h-[100px] tw-p-0 tw-relative tw-bg-black/25 tw-rounded-[999px] tw-border tw-border-solid tw-border-black/30 tw-flex tw-flex-col tw-items-center tw-justify-center"
          type="button"
          disabled
        >
          <video
            muted
            playsInline
            autoPlay
            loop
            style={{ objectFit: "cover" }}
            key={correctSrc as string}
            className="tw-rounded-[999px] tw-w-full tw-h-full"
          >
            <source src={correctSrc}></source>
          </video>

          {message && (
            <div
              className="tw-left-0 tw-top-0 tw-right-0 tw-bottom-0 tw-flex tw-flex-col tw-p-2 tw-overflow-hidden tw-rounded-full tw-items-center tw-justify-center tw-absolute tw-text-center tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal"
              style={{
                color: widgetUtils.bgColorMapper[notificationMessageColor]
              }}
            >
              {message}
            </div>
          )}
        </button>
        {hasNotificationBadge && (
          <div className="tw-w-2.5 tw-h-2.5 tw-left-[5px] tw-top-[87px] tw-absolute tw-bg-[red] tw-animate-pulse tw-rounded-[5px] tw-shadow-[0_0_0_2px_rgba(0,0,0,0.2)]" />
        )}
      </div>
    );

  return (
    <div className="tw-w-[120px] tw-h-[213px] tw-aspect-[9/16] tw-p-0.5 tw-bg-black/25 tw-rounded-2xl tw-border tw-border-black/30 tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center">
      <video
        muted
        playsInline
        autoPlay
        loop
        key={correctSrc as string}
        style={{ objectFit: "cover" }}
        className="tw-rounded-2xl tw-w-full tw-h-full"
      >
        <source src={correctSrc as string}></source>
      </video>

      <div className="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-z-[1] tw-flex-col tw-justify-start tw-items-center tw-inline-flex">
        <div className="tw-self-stretch tw-justify-end tw-items-end tw-gap-2.5 tw-inline-flex tw-z-[2]">
          <div className="tw-bg-black tw-justify-start tw-items-center tw-gap-2.5 tw-flex tw-w-5 tw-h-5 tw-relative tw-rounded-[20px] tw-text-white">
            <BiX size={20} />
          </div>
        </div>
        {message && (
          <div
            className="tw-self-stretch tw-text-center tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal my-auto"
            style={{ color: notificationMessageColor }}
          >
            {message}
          </div>
        )}
        {hasNotificationBadge && (
          <div
            className={`tw-self-stretch tw-pl-1 tw-pb-1 tw-justify-start tw-items-start tw-gap-2.5 tw-inline-flex ${
              !message ? "mt-auto" : ""
            }`}
          >
            <div className="tw-w-2.5 tw-h-2.5 tw-relative tw-bg-[red] tw-animate-pulse tw-rounded-[5px] tw-shadow" />
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoToggleIcon;
